import { WebsiteDesignType } from "../../Types/Widgets.type";
import { CryptoDashboard, Href, PodcastWebdesign, SocialPostDesign, WebsiteDesign } from "../../Utils/Constants";
import { radialCommonOption, radialCommonOption2, radialCommonOption3, radialCommonOption4 } from "./WidgetsChartData";

export const dailyDropdownList = ['Today', 'Tomorrow', 'Yesterday'];

export const socialWidgetsData = [
    {
        image: "1",
        alt: "facebook icon",
        title: "Facebook",
        count: "+22.9%",
        followers: "12,098",
        content: "Followers",
        id: "radial-facebook",
        chart: radialCommonOption
    },
    {
        image: "3",
        alt: "twitter icon",
        title: "Twitter",
        count: "+14.09%",
        followers: "12,564",
        content: "Followers",
        id: "radial-twitter",
        chart: radialCommonOption3
    },
    {
        image: "2",
        alt: "instagram icon",
        title: "Instagram",
        count: "+27.4%",
        followers: "15,080",
        content: "Followers",
        id: "radial-instagram",
        chart: radialCommonOption2
    },
    {
        image: "4",
        alt: "you tube icon",
        title: "Youtube",
        count: "+22.9%",
        followers: "68,954",
        content: "Followers",
        id: "radial-youtube",
        chart: radialCommonOption4
    }
]

export const totalStudentData = [
    {
        student: "42,954",
        title: "Total Students",
        color: "danger",
        icon: "down",
        percentage: "- 17.06%",
        detail: "than last 6 Month",
        image: "student.png",
        class: "student"
    },
    {
        student: "659",
        title: "Total Teachers",
        color: "success",
        icon: "up",
        percentage: "+27.02%",
        detail: "than last 4 Month",
        image: "teacher.png",
        class: "student-2"
    },
    {
        student: "984",
        title: "Events",
        color: "success",
        icon: "up",
        percentage: "+ 12.01%",
        detail: "than last 8 Month",
        image: "calendar.png",
        class: "student-3"
    },
    {
        student: "1,984",
        title: "Invoice Status",
        color: "danger",
        icon: "down",
        percentage: "- 15.02%",
        detail: "than last 5 Month",
        image: "invoice.png",
        class: "student-4"
    },
]

export const websiteDesignData: WebsiteDesignType[] = [
    {
        class: "proorder-md-7",
        title: WebsiteDesign,
        img: "16.png",
        link: Href,
        header: "Square Dashboard",
        email: "karson123@gmail.com",
        btn: [
            {
                color: "primary",
                btnName: "UX Design"
            },
            {
                color: "secondary",
                btnName: "3D Deisgn"
            }
        ],
        ratting: [
            {
                total: "12",
                detail: "Issues"
            },
            {
                total: "5",
                detail: "Resolved"
            },
            {
                total: "7",
                detail: "Comment"
            }
        ],
        task: "6",
        color: "primary",
        value: "50"
    },
    {
        class: "proorder-md-8",
        title: SocialPostDesign,
        img: "18.png",
        link: Href,
        header: "Cronin Lewis",
        email: "cronin324@gmail.com",
        btn: [
            {
                color: "primary",
                btnName: "Illustration"
            },
            {
                color: "warning",
                btnName: "Video Editing"
            }
        ],
        ratting: [
            {
                total: "10",
                detail: "Issues"
            },
            {
                total: "9",
                detail: "Resolved"
            },
            {
                total: "5",
                detail: "Comment"
            }
        ],
        task: "4",
        color: "secondary",
        value: "40"
    },
    {
        class: "proorder-md-9",
        title: PodcastWebdesign,
        img: "17.png",
        link: Href,
        header: "Rau Foster",
        email: "raufoster23@gmail.com",
        btn: [
            {
                color: "tertiary",
                btnName: "2D Design"
            },
            {
                color: "secondary",
                btnName: "Dribbble Post"
            }
        ],
        ratting: [
            {
                total: "16",
                detail: "Issues"
            },
            {
                total: "10",
                detail: "Resolved"
            },
            {
                total: "7",
                detail: "Comment"
            }
        ],
        task: "8",
        color: "warning",
        value: "80"
    },
    {
        class: "proorder-md-10",
        title: CryptoDashboard,
        img: "19.png",
        link: Href,
        header: "Volkman Melisa",
        email: "volkman839@gmail.com",
        btn: [
            {
                color: "primary",
                btnName: "Design System"
            },
            {
                color: "secondary",
                btnName: "Branding"
            }
        ],
        ratting: [
            {
                total: "04",
                detail: "Issues"
            },
            {
                total: "5",
                detail: "Resolved"
            },
            {
                total: "7",
                detail: "Comment"
            }
        ],
        task: "2",
        color: "tertiary",
        value: "20"
    }
]

export const upcomingData = [
    {
        img: "5.png",
        link: Href,
        name: "John Elliot",
        date: "21 Oct 2024",
        time: "15:55 AM"
    },
    {
        img: "4.png",
        link: Href,
        name: "Ashley Hart",
        date: "12 Oct 2024",
        time: "10:20 AM"
    },
    {
        img: "3.png",
        link: Href,
        name: "Anna lverson",
        date: "05 Oct 2024",
        time: "14:30 AM"
    },
    {
        img: "2.png",
        link: Href,
        name: "Dana Lemon",
        date: "01 Oct 2024",
        time: "18:45 AM"
    }
]
